//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  name: 'PreviewModeBlock',
  components: {
    TimeSince: () => import('@motionelements/core/src/components/ui/BaseTimeSince.vue'),
  },
  props: {
    product: {
      type: Object, // id, publishedAt, createdAt
      required: true,
    },
  },
  computed: {
    ...mapState({
      userLanguage: state => state.user.language,
    }),
    publishedAt() {
      return this.product.publishedAt;
    },
    createdAt() {
      return this.product.createdAt;
    },
  },
};
